export enum RecommendationTopic {
  Abstract = 'abstract',
  Animals = 'animals',
  Art = 'art',
  Architecture = 'architecture',
  Beauty = 'beauty',
  BlackWhite = 'black-white',
  Business = 'business',
  Fashion = 'fashion',
  Finance = 'finance',
  FoodDrink = 'food-drink',
  Health = 'health',
  Holidays = 'holidays',
  Home = 'home',
  Industry = 'industry',
  Lifestyle = 'lifestyle',
  Music = 'music',
  Nature = 'nature',
  Objects = 'objects',
  Products = 'products',
  People = 'people',
  RealEstate = 'real-estate',
  Sports = 'sports',
  Technology = 'technology',
  Travel = 'travel',
  Weddings = 'weddings',
}

export const DEFAULT_TOPICS = [
  RecommendationTopic.Business,
  RecommendationTopic.FoodDrink,
  RecommendationTopic.Technology,
  RecommendationTopic.Home,
  RecommendationTopic.People,
];
